module.exports = __webpack_public_path__ + "img/Ethereum.407ba390.png";